var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F4F5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.956 18.536C22.9804 21.1303 25.2622 21.9936 25.2875 22.0046C25.2682 22.0655 24.9229 23.2349 24.0853 24.4428C23.3613 25.4871 22.6098 26.5276 21.4261 26.5491C20.2629 26.5703 19.8889 25.8685 18.5591 25.8685C17.2297 25.8685 16.8141 26.5276 15.7131 26.5703C14.5705 26.613 13.7004 25.441 12.9703 24.4005C11.4786 22.2722 10.3385 18.3864 11.8693 15.7634C12.6297 14.4608 13.9887 13.6359 15.4638 13.6148C16.5858 13.5936 17.6448 14.3597 18.3307 14.3597C19.0162 14.3597 20.3032 13.4385 21.6562 13.5737C22.2225 13.597 23.8124 13.7995 24.8333 15.2742C24.7511 15.3245 22.9363 16.3671 22.956 18.536ZM20.77 12.1657C21.3766 11.441 21.7849 10.4323 21.6735 9.42856C20.7991 9.46324 19.7418 10.0036 19.1146 10.7278C18.5525 11.3692 18.0602 12.3957 18.1931 13.3795C19.1677 13.4539 20.1633 12.8908 20.77 12.1657Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.9f9e4d58d1c4c6361bf616aa2481e4b2.svg";
export { ForwardRef as ReactComponent };